<template>
  <v-container>
    <v-row cols="12">
      <v-col>
        <img src="../../assets/img/easycob.png" height="50px" />
      </v-col>

      <v-col align="end">
        <img
          class="plural"
          src="../../assets/img/logo-Plural2.png"
          height="50px"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="8">
        <div>
          <code>Nome do Cliente</code><br />
          <b>{{ nome }}</b
          ><br />
        </div>
      </v-col>
      <v-col cols="3">
        <code>(=) Valor do Documento</code><br />
        <b>R$ {{ valor | dinheiro }}</b>
      </v-col>
      <v-col cols="1">
        <code>Vencimento</code><br />
        <b>{{ venc | dataF }}</b>
      </v-col>
    </v-row>
    <!--
    <v-row>
      <v-col class="entre-linha">
        <p>
          Anexamos o boleto bancário referente ao acordo firmado com a Easycob,
        </p>
        <p>empresa prestadora de serviços da <b>PLURAL</b>.</p>
      </v-col>
    </v-row>
  -->
    <v-row>
      <v-col class="entre-linha">
        <p>
          Seu acordo em {{ quantas_vezes }} vez(es) de R$
          {{ valor | dinheiro }} foi registrado em nosso
        </p>
        <p>sistema e será submetido a aprovação da Plural.</p>
        <p>O presente pré-acordo será analisado e validado pelo Credor.</p>
        <p>
          Caso aprovado, o boleto bancário correspondente será emitido e enviado
        </p>
        <p>no prazo de até 48 horas úteis.</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <h4>DEMONSTRATIVO DE FATURA(S):</h4>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="subtitle-2 entre-linha">
        <p v-for="i in faturas" :key="i.nundoc">
          {{ i.pdnumdoc }} - {{ i.pddtvencto | dataF }} -
          <b>R$ {{ i.pdvalor | dinheiro }}</b>
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="entre-linha">
        <p>NOSSOS MEIOS DE COMUNICAÇÃO: (21) 2206-4811 / 0800-075-0424</p>
        <p>E-mail: boleto@easboleto.com.br</p>
        <p>
          <a
            class="nodeco"
            href="https://api.whatsapp.com/send?phone=552122064811&text=Realizei%20uma%20negocia%C3%A7%C3%A3o%20no%20site%20referente%20%C3%A0%20Plural%20Sa%C3%BAde"
            target="_blank"
          >
            Whatsapp: (21) 2206-4811
          </a>
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { api } from "@/conf/api";
import { atualizarLogNegoc } from "@/conf/logNegoc";
export default {
  name: "BolPlural",
  data() {
    return {
      nome: "",
      valor: "",
      venc: "",
      faturas: [],
      quantas_vezes: "",
      divida: null,
      datahoje: new Date().toISOString().substring(0, 10),
      email: "",
    };
  },
  filters: {
    dinheiro: function(value) {
      return parseFloat(value)
        .toFixed(2)
        .replace(".", ",");
    },
    dataF: function(d2) {
      let d = d2.substr(0, 10);
      return d.substr(8, 2) + "/" + d.substr(5, 2) + "/" + d.substr(0, 4);
    },
  },
  async beforeMount() {
    this.$store.dispatch("setMostraBotoes", { imprimir: true, voltar: false });

    this.divida = this.$store.state.divida_atual;
    console.log("item", this.divida);
    let contratoMeu = this.divida.contrato;
    let negoc = this.$store.state.negoc_atual;
    console.log("neg", negoc);
    let valores = this.$store.state.unismg_valores.find((e) => {
      return e.contrato == contratoMeu;
    });
    console.log("valores", valores);
    this.faturas = valores.faturas;

    this.email = this.$store.state.emailCli;
    //console.log('email',this.email)
    this.venc = this.$store.state.venc_atual;
    //console.log('venc',this.venc)

    this.nome = this.divida.nome;
    let v = 99999999;
    this.quantas_vezes = parseInt(negoc.parcelas) + 1;
    let logNegoc = this.$store.state.logNegoc;
    logNegoc.log_status = `cpf ${logNegoc.cpf} entrou na página de Boleto Plural`;
    logNegoc.parcelas_qtde = this.quantas_vezes;

    if (this.quantas_vezes == 1) {
      v = valores._1x;
    }
    if (this.quantas_vezes == 2) {
      v = valores._2xdemais;
    }
    if (this.quantas_vezes == 3) {
      v = valores._3xdemais;
    }
    this.valor = v;

    logNegoc.entrada = this.valor;

    await atualizarLogNegoc(logNegoc);

    //------------------------------------------------

    let dados = {
      credor: "PLURAL",
      cpf: this.divida.cpcpfcgc,
      contrato: this.divida.contrato,
      valor: this.valor,
      venc: this.venc,
      fatura: null,
      codBarras: "",
      L_dig: "",
      remessa: null,
      parcelas_faltam: negoc.parcelas,
      email: this.email,
      valor_entrada: null,
      valor_parcela: null,
    };
    await api.post(`logs/gravaacordosomente`, dados);

    //------------------------------------------------
  },
};
</script>

<style scoped>
.entre-linha {
  line-height: 0.3rem;
}
.nodeco {
  text-decoration: none;
  color: black;
}
</style>
